import React, { useState } from "react"
import axiosInstance from "../../utils/axiosInstance"
import { API_ENDPOINTS } from "../../constants/config"

function AddSchoolModal({ isOpen, onClose, onSchoolAdded }) {
  const [newSchool, setNewSchool] = useState({ 
    name: "", 
    domain: "", 
    adminPassword: "",
    address: {},
    location: {},
    phone: "",
    email: "",
    website: "",
    description: "",
    foundedYear: "",
    group: "",
    tenantType: "industry",
  })
  const [error, setError] = useState("")

  const handleSchoolSubmit = async (e) => {
    e.preventDefault()
    try {
      const token = localStorage.getItem("token")
      await axiosInstance.post(API_ENDPOINTS.schools, newSchool, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setNewSchool({ 
        name: "", 
        domain: "", 
        adminPassword: "",
        address: {},
        location: {},
        phone: "",
        email: "",
        website: "",
        description: "",
        foundedYear: "",
        group: "",
        tenantType: "industry",
      })
      onSchoolAdded()
      onClose()
    } catch (error) {
      setError(error.response?.data?.message || "Failed to create customer")
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl w-96">
        <h2 className="text-2xl font-bold mb-6 text-center">Create New Customer</h2>
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            {error}
          </div>
        )}
        <form onSubmit={handleSchoolSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Customer Name"
            value={newSchool.name}
            onChange={(e) => setNewSchool({...newSchool, name: e.target.value})}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="text"
            placeholder="Customer Domain"
            value={newSchool.domain}
            onChange={(e) => setNewSchool({...newSchool, domain: e.target.value})}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <select
            value={newSchool.tenantType}
            onChange={(e) => setNewSchool({ ...newSchool, tenantType: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="school">School</option>
            <option value="industry">Industry</option>
          </select>
          <input
            type="password"
            placeholder="Admin Password"
            value={newSchool.adminPassword}
            onChange={(e) => setNewSchool({...newSchool, adminPassword: e.target.value})}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="email"
            placeholder="Customer Email"
            value={newSchool.email}
            onChange={(e) => setNewSchool({...newSchool, email: e.target.value})}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="text"
            placeholder="Customer group (e.g. dps) - optional"
            value={newSchool.group}
            onChange={(e) => setNewSchool({...newSchool, group: e.target.value})}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <p className="text-xs text-gray-500 -mt-2">Same group = Super Customer Admin will see these customers together.</p>
          <div className="flex space-x-4">
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Create Customer
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full bg-gray-200 text-gray-700 py-2 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddSchoolModal